"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Switch = require("./Switch.styles");
var _excluded = ["value", "onChange"];
var Switch = function Switch(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Switch.IOSSwitch, (0, _extends2["default"])({
    checked: value,
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    }
  }, params));
};
var _default = exports["default"] = Switch;